export const DEFAULT_TIMEZONE = 'Europe/Berlin'

export const LOWEST_MARK = 'Not graded'

export const LOWEST_POSSIBLE_MARK = {
  id: 0,
  name: LOWEST_MARK,
  lowerBound: 0,
}
